import React, { useState } from "react";
import pop from '../assets/img/brunchSeptember.jpg';

const Modal = () => {
  const [showModal, setShowModal] = useState(false);
  // to show the modal just change the false into true
  return (
    <>
      {showModal ? (
        <>
          <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-end p-5 border-b border-solid border-gray-300 rounded-t ">
                  <button className="bg-transparent border-0 text-black"
                    onClick={() => setShowModal(false)}>
                    <span className="font-bold opacity-7 h-6 w-6 text-2xl block py-0 rounded-full">
                      x</span> </button>
                </div>
                <div className="relative p-6 flex-auto "><img src={pop} alt='announcement' className="rounded-lg" /></div>
                
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default Modal;